import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Meetings from "./Components/Meetinglist/Meetings";
import Daily from "./Components/DailyReflection/Daily";
import Faq from "./Components/FAQ/Faq";
import Contact from "./Components/Contact/Contact";
import StepsPage from "./Components/Service/Stepspage";
import StepsPage1 from "./Components/Service/Stepspage1";
import StepsPage2 from "./Components/Service/Stepspage2";
import SlogansPage from "./Components/Service/slogan";
import AAMeetingsPage from "./Components/Service/AAmeeting";
import AAExperience from "./Components/Service/AAexperience";
import AAHistory from "./Components/Service/AAhistory";
import PopupNotice from "./Components/PopupNotice";
import "./assets/scss/fonts.scss";
import LiteraturePage from "./Components/Service/AAliteraturepage";
import TwelvePrinciples from "./Components/Service/TwelvePrinciples";
import HowAAWorks from "./Components/Service/HowAAWorks";
import ScrollToTop from "./Components/ScrollToTop";
import BigBookAudio from "./Components/Service/AAbigbookaudio";

function ReactRouter() {
    return (
        <>
            <PopupNotice />
            <ScrollToTop/>

            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/meetings" element={<Meetings />} />
                <Route path="/dailyreflections" element={<Daily />} />
                <Route path="/selftest" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/unity" element={<StepsPage />} />
                <Route path="/service" element={<StepsPage2 />} />
                <Route path="/recovery" element={<StepsPage1 />} />
                <Route path="/slogans" element={<SlogansPage />} />
                <Route path="/aa-meetings" element={<AAMeetingsPage />} />
                <Route path="/aa-experience" element={<AAExperience />} />
                <Route path="/aa-history" element={<AAHistory />} />
                <Route path="/literature" element={<LiteraturePage />} />
                <Route path="/twelve-principles" element={<TwelvePrinciples />} />
                <Route path="/how-aa-works" element={<HowAAWorks />} />
                <Route path="/bigbook-audio" element={<BigBookAudio/>} />

            </Routes>
        </>
    );
}

export default ReactRouter;
